import { useState, useEffect, useCallback, useRef } from "react";
import { Row, Col, Space, Input, message, Button, Typography } from "antd";
import Data from "../../../CustomText/data";
import API from "../../../../services/API";
import { formatDate } from "../../../../helpers/genericHelper";

export default function ProfileInfo({
  userId,
  subscriptions,
  creditCards,
  all
}) {

  const inputRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [notes, setNotes] = useState(null);
  const [note, setNote] = useState(null);
  const [userNames, setUserNames] = useState({});
  const [loadingUserNames, setLoadingUserNames] = useState({});

  useEffect(() => {
    getNotes();
  }, [userId]);

  const getUserNames = useCallback((id) => {
    if (userNames[id]) {
      return userNames[id];
    }

    if (loadingUserNames[id]) {
      return id;
    }
    try {
      API.getUserSummary({ userId: id }).then((data) => {
        console.log('data', data);
        setUserNames((userNames) => ({ ...userNames, [id]: `${data?.firstName} ${data?.lastName}` }));
      }).catch((error) => console.log('error', error));
    } catch (error) { }

    setLoadingUserNames({ ...loadingUserNames, [id]: true });

    return id;
  })

  const getNotes = async () => {
    setLoading(true);
    try {
      const res = await API.getUserNotes({userId});
      setNotes(res.sort((a, b) => new Date(b.createTs) - new Date(a.createTs)));
    } catch (error) {
      message.error('Unable to fetch User Notes');
    } finally {
      setLoading(false);
    }
  }

  const submitNote = async () => {
    setLoading(true);
    try {
      await API.postUserNote({
        userId,
        message: note
      });
      setNote('');
      if (inputRef.current) {
        inputRef.current.input.value = '';
        inputRef.current.focus();
        console.log('inputRef.current', inputRef.current);
      }
      getNotes();
    } catch (error) {
      message.error('Unable to add note');
    } finally {
      setLoading(false);
    }
  }

  return <>
    <h3>Notes</h3>
    <Space direction="vertical" style={{ width: '100%' }}>
      { notes && notes.length > 0 && <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
          {notes.map((note) => 
            <Row>
              <Col span="24">
                <Typography.Text style={{ display: 'block' }} type="secondary" strong>
                  <small>{getUserNames(note.supportUserId)}:</small>
                </Typography.Text>
                {note.message}
                <Typography.Text style={{ display: 'block' }} type="secondary" strong>
                  <small>
                    - {formatDate(note.createTs, true)}
                  </small>
                </Typography.Text>
              </Col>
            </Row>
          )}
      </div>}
      { notes && notes.length === 0 && <>
          <Typography.Text style={{ display: 'block' }} type="secondary" strong><small>No notes have been added yet.</small></Typography.Text>
        </>
      }
      <Input.Group compact>
        <Input value={note} style={{ width: 'calc( 100% - 80px )' }} onChange={(val) => setNote(val.target.value)} ref={inputRef} />
        <Button type="primary" onClick={submitNote} disabled={loading}>Post</Button>
      </Input.Group>
    </Space>
  </>
}